import React from 'react';
import { GitBranch } from 'lucide-react';

const mappingFor = (lookup, line) =>
  (line.cobranding_id && lookup[`${line.product_id}:${line.cobranding_id}`]) || lookup[line.product_id];

export const countSeasonal = (lines, lookup) => {
  const filled = lines.filter((l) => l.product_id);
  const seasonal = filled.filter((l) => mappingFor(lookup || {}, l)?.is_seasonal).length;
  return { seasonal, normal: filled.length - seasonal };
};

export const SeasonalSplitNotice = ({ lines, lookup }) => {
  const { seasonal, normal } = countSeasonal(lines, lookup);
  if (!seasonal) return null;
  const text = normal
    ? `${seasonal} seasonal product line${seasonal > 1 ? 's' : ''} will be kept on their own linked order under the same PO when you submit, so they can go out in several dispatches.`
    : 'All lines are seasonal products. Use Split Fulfilment in the Order Pipeline to send this PO in several dispatches.';
  return (
    <div className="flex items-start gap-2 rounded-lg border border-primary/30 bg-primary/5 px-3 py-2 text-sm text-primary" data-testid="seasonal-split-notice">
      <GitBranch className="mt-0.5 h-4 w-4 flex-shrink-0" />
      <span>{text}</span>
    </div>
  );
};

export const SplitCreatedNote = ({ phased }) => {
  const extra = (phased?.parts || []).filter((p) => p.seasonal);
  if (!extra.length) return null;
  return (
    <p className="mb-4 rounded-lg bg-primary/5 px-3 py-2 text-sm text-primary" data-testid="order-success-phased">
      Seasonal lines kept on linked order {extra.map((p) => `#${p.dispatch_number} (Part ${p.part_number})`).join(', ')} under the same PO.
    </p>
  );
};
